import React from 'react';
import Typography from '@material-ui/core/Typography';
import moment from 'moment-timezone';

import { shift as shiftConsts } from '../../../../constants';

const timeFormat = 'HH:mm';
const timezoneFormat = 'z';

const ScheduleAppointment = model => {
  const { startDate, endDate, timezone, status } = model;
  const startMoment = moment(startDate).tz(timezone ? timezone : moment.tz.guess());
  const endMoment = moment(endDate).tz(timezone ? timezone : moment.tz.guess());

  return (
    <>
      <Typography>{shiftConsts.statusValueLookup[status].text}</Typography>
      <Typography variant={'caption'}>{`${startMoment.format(timeFormat)} - ${endMoment.format(timeFormat)} ${startMoment.format(timezoneFormat)}`}</Typography>
    </>
  )
}

export default ScheduleAppointment;